import React, {useEffect, useState} from "react";
import Header from "../components/header/Header";
import Greeting from "./greeting/Greeting";
import Skills from "./skills/Skills";
import StackProgress from "./skillProgress/skillProgress";
import WorkExperience from "./workExperience/WorkExperience";
import Projects from "./projects/Projects";
import StartupProject from "./StartupProjects/StartupProject";
import Achievement from "./achievement/Achievement";
import Blogs from "./blogs/Blogs";
import Footer from "../components/footer/Footer";
import Talks from "./talks/Talks";
import Podcast from "./podcast/Podcast";
import Education from "./education/Education";
import ScrollToTopButton from "./topbutton/Top";
import Twitter from "./twitter-embed/twitter";
import Profile from "./profile/Profile";
import SplashScreen from "./splashScreen/SplashScreen";
import {splashScreen} from "../portfolio";
import {StyleProvider} from "../contexts/StyleContext";
import {useLocalStorage} from "../hooks/useLocalStorage";
import "./Main.scss";
import LegalNotice from "./legalNotice/LegalNotice";
import Accessibility from "./accessibility/Accessibility";
import Privacy from "./privacy/Privacy";

const Main = () => {
  const prefersDark =
    window.matchMedia?.("(prefers-color-scheme: dark)")?.matches ?? false;
  const prefersReducedMotion =
    window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;
  const [isDark, setIsDark] = useLocalStorage("isDark", prefersDark);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] = useState(
    splashScreen.enabled && !prefersReducedMotion
  );
  const [isLegalNotice, setIsLegalNotice] = useState(
    window.location.hash === "#/mentions-legales"
  );
  const [isAccessibility, setIsAccessibility] = useState(
    window.location.hash === "#/accessibilite"
  );
  const [isPrivacy, setIsPrivacy] = useState(
    window.location.hash === "#/confidentialite"
  );

  useEffect(() => {
    if (splashScreen.enabled && !prefersReducedMotion) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    }
  }, [prefersReducedMotion]);

  useEffect(() => {
    const handleRouteChange = () => {
      setIsLegalNotice(window.location.hash === "#/mentions-legales");
      setIsAccessibility(window.location.hash === "#/accessibilite");
      setIsPrivacy(window.location.hash === "#/confidentialite");
      window.scrollTo(0, 0);
    };

    window.addEventListener("hashchange", handleRouteChange);
    return () => window.removeEventListener("hashchange", handleRouteChange);
  }, []);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "dark-mode" : null}>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        {isShowingSplashAnimation && splashScreen.enabled ? (
          <SplashScreen />
        ) : (
          <>
            {!isLegalNotice && !isAccessibility && !isPrivacy && <Header />}
            {isLegalNotice ? (
              <LegalNotice />
            ) : isAccessibility ? (
              <Accessibility />
            ) : isPrivacy ? (
              <Privacy />
            ) : (
              <main id="main-content" tabIndex="-1">
                <Greeting />
                <Skills />
                <StackProgress />
                <WorkExperience />
                <StartupProject />
                <Achievement />
                <Education />
                <Projects />
                <Profile />
                <Blogs />
                <Twitter />
                <Podcast />
                <Talks />
              </main>
            )}
            <Footer />
            {!isLegalNotice && !isAccessibility && !isPrivacy && (
              <ScrollToTopButton />
            )}
          </>
        )}
      </StyleProvider>
    </div>
  );
};

export default Main;
